import React from 'react';
import ReactDOM from 'react-dom';
const getModal = () => document.getElementById('modal-root');
let modalRoot = getModal();
export default class Modal extends React.Component {
    constructor(props) {
        super(props);
        this.el = document.createElement('div');
    }
    componentDidMount() {
        if (!modalRoot && !(modalRoot = getModal())) {
            throw new Error('Missing #modal-root element');
        }
        modalRoot.appendChild(this.el);
    }
    componentWillUnmount() {
        if (!modalRoot && !(modalRoot = getModal())) {
            throw new Error('Missing #modal-root element');
        }
        modalRoot.removeChild(this.el);
    }
    render() {
        return ReactDOM.createPortal(this.props.children, this.el);
    }
}
